import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "row header p-0 m-0",
  id: "kt_header"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTBarraColores = _resolveComponent("KTBarraColores")!
  const _component_FamiliaInfo = _resolveComponent("FamiliaInfo")!
  const _component_KTLogos = _resolveComponent("KTLogos")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_KTBarraColores),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_FamiliaInfo),
      _createVNode(_component_KTLogos)
    ])
  ], 64))
}